import type { ImpersonationUserOption } from "@/core/impersonation/impersonation-options";
import { USER_ROLES } from "@/user/constants";

export type ImpersonationParentType = "tenant" | "business";

const BUSINESS_USER_ROLE_ORDER = [
  USER_ROLES.OWNER,
  USER_ROLES.MANAGER,
  USER_ROLES.REP,
  USER_ROLES.TECH,
  USER_ROLES.AP_ONLY,
];

export const getImpersonationUserOptions = (
  users: ImpersonationUserOption[] | undefined,
  parentType: ImpersonationParentType,
) => {
  const nonAdminUsers =
    users?.filter((user) => user.role !== USER_ROLES.ADMIN) ?? [];

  const orderedUsers =
    parentType === "tenant"
      ? nonAdminUsers
      : BUSINESS_USER_ROLE_ORDER.flatMap((role) =>
          nonAdminUsers.filter((user) => user.role === role),
        );

  return orderedUsers.map((user) => ({
    value: user.id,
    label:
      user.first_name && user.last_name
        ? `${user.first_name} ${user.last_name} (${user.email}, ${user.role.toLowerCase()})`
        : `${user.email}, ${user.role.toLowerCase()}`,
  }));
};
